export * from "./EditButton";

export interface IEditButtonProps {
    Caption: string;
    OnClick: () => void;
}

export interface IEditButtonStyleProps {
    IsHovering: boolean;
}
